'use strict';
const clearErrors = (form) => {
    form.querySelectorAll('[data-error-for]').forEach((node) => {
        node.textContent = '';
        node.hidden = true;
    });
    form.querySelectorAll('.has-error').forEach((node) => {
        node.classList.remove('has-error');
    });
    const formError = form.querySelector('[data-form-error]');
    if (formError) {
        formError.textContent = '';
        formError.hidden = true;
    }
};
const showErrors = (form, errors) => {
    Object.keys(errors).forEach((field) => {
        const target = form.querySelector(`[data-error-for="${field}"]`);
        if (target) {
            target.textContent = errors[field];
            target.hidden = false;
        }
        const input = form.querySelector(`[name="${field}"]`);
        if (input) {
            input.classList.add('has-error');
        }
    });
    const first = form.querySelector('.has-error');
    if (first) {
        first.focus();
    }
};
const showFormError = (form, message) => {
    const formError = form.querySelector('[data-form-error]');
    if (!formError) {
        return;
    }
    formError.textContent = message;
    formError.hidden = false;
};
const initForm = (widget) => {
    const form = widget.querySelector('form');
    const ajaxUrl = widget.dataset.ajaxUrl;
    if (!form || !ajaxUrl) {
        return;
    }
    const submit = form.querySelector('[type="submit"]');
    form.addEventListener('submit', (event) => {
        event.preventDefault();
        clearErrors(form);
        if (submit) {
            submit.disabled = true;
        }
        fetch(ajaxUrl, { method: 'POST', body: new FormData(form) })
            .then((response) => response.json())
            .then((data) => {
            var _a;
            if (data.success) {
                const thanks = widget.querySelector('.thank-you-message');
                // The block renders its own (translated) message; the server's
                // text only fills in when the block has none.
                if (thanks && data.message && !((_a = thanks.textContent) === null || _a === void 0 ? void 0 : _a.trim())) {
                    thanks.textContent = data.message;
                }
                form.reset();
                widget.classList.add('submitted');
                return;
            }
            if (data.errors) {
                showErrors(form, data.errors);
            }
            if (data.message) {
                showFormError(form, data.message);
            }
        })
            .catch(() => {
            showFormError(form, form.dataset.genericError || 'Something went wrong. Please try again.');
        })
            .finally(() => {
            if (submit) {
                submit.disabled = false;
            }
        });
    });
};
document.addEventListener('DOMContentLoaded', () => {
    document
        .querySelectorAll('.block.contact-form .contact-form__widget')
        .forEach(initForm);
});
